<script>
    import * as Translations from '@scanex/translations';
    import { createEventDispatcher, onMount, onDestroy } from 'svelte';
    import { visibility } from './store.js';
    import FileBrowser from './FileBrowser.svelte';
    import './Region.css';

    export let id = '';
    export let geoJSON = null;
    export let name = '';
    export let granules = [];
    export let tiles = []; //
    export let geoTiffs = []; //
    //export const order = {}; // ?
    export let visible = false;    
    export let filePath = '';

    let expanded = false;    
    let selected = -1;
    let selected2 = -1;
    let selected3 = -1;

    Translations.add('en', {
        product: 'Product',        
    });

    Translations.add('ru', {
        product: 'Продукт',        
    });

    /*let checked = false;
    let unchecked = true;
    let undetermined = false;

    $: {
        checked = granules.every(({granule: {product}}) => product.checked);
        undetermined = !checked && granules.some(({granule: {product}}) => product.checked);
        unchecked = !checked && !undetermined;
    }*/

    /*const toggle = () => {
        let items = granules.slice();
        items.forEach(({granule: {product}}) => {
            product.checked = unchecked;
        });
        granules = items;
    };*/

    const dispatch = createEventDispatcher();

    const reset = () => {
        console.log('reset');
        selected = -1;
        selected2 = -1;
        selected3 = -1;
    };

    const select = i => {
        console.log('select_grn');
        selected = i;
        selected2 = -1
        selected3 = -1;
        const {granule} = granules[i];
        //const tileName = tiles[i].tileName
        dispatch('select', {...granule, reset});
    }

    const select2 = i => {
        selected2 = i;
        selected = -1;
        selected3 = -1;
        const tileName = tiles[i].tileName;
        //console.log(i, tiles[i], granules[i])
        dispatch('select', {tileName, reset});
    };

    const select22 = i => {
        selected2 = i;
        }

    const select3 = i => {
        selected2 = -1;
        selected = -1;
        selected3 = i;
    };
    
    const download = () => {        
        let fileBrowser = new FileBrowser({target: document.body});
        let p = filePath.replace('\\', '/');    
        const i = p.lastIndexOf('/');    
        const path = i < 0 ? p : p.substr(0, i);
        dispatch('expand', {
            expand: files => fileBrowser.$set({files}),
            filePath: path,
        });
        fileBrowser.$on('expand', ({detail}) => dispatch('expand', detail));
        fileBrowser.$on('close', () => {            
            fileBrowser.$destroy();
        });
        fileBrowser.$on('download', () => {            
            fileBrowser.$destroy();
            dispatch('download');
        });
        fileBrowser.$on('selection', ({detail}) => {
            dispatch('selection', detail);
        });
    };

    const preview = () => {        
        visible = !visible;     
        if (visible) {
            visibility.set(true);
        }
                        
        const gs = granules.reduce((a, {granuleId}) => {
            a[granuleId] = true;
            return a;
        }, {});
        dispatch('preview', {id, visible, granules: gs, geoJSON});
    };

    let unsubscribe = visibility.subscribe(value => {
        if (!value) {
            visible = false;
        }
    });

    onDestroy(() => {
        unsubscribe();        
    });
    
</script>

<div class="roi">
    <table class="header" class:collapsed="{!expanded}">
        <tr>
            <td on:click="{() => expanded = !expanded}">
                <i class="toggle icon" class:caret-right="{!expanded}" class:caret-down="{expanded}"></i>
            </td>
            <td on:click|stopPropagation="{preview}">
                <i class="preview icon" class:eye="{visible}" class:eye-invisible="{!visible}"></i>
            </td>
            <td class="name" on:click|stopPropagation="{() => expanded = !expanded}">{name}</td>
            <td on:click|stopPropagation="{download}">
                <i class="icon download" class:caret-down="{expanded}" class:caret-right="{!expanded}"></i>
            </td>
        </tr>                                
    </table>
    <table style="table-layout: fixed; width:80% " class="content" class:hidden="{!expanded}" cellpadding="0" cellspacing="0">
        <tr >
            <th>{'Данные заказа'}</th>            
            <th>{"0 Mб"}</th>            
        </tr>
        {#each granules.filter(({granule: {productType}}) => productType !== 100001 || productType !== null ) as g, i}
        <tr class:selected="{i === selected}" on:click="{() => select(i)}">
            <td style="overflow: hidden; text-overflow: ellipsis;">
                {g.granule.sceneId}
            </td>           
            <td>
                <i class="icon info-circle"></i>
                <i class="icon"></i>
                <i class="icon square"></i>
            </td> 
        </tr>
        {/each}
        <tr>
            <th>{'Результат заказа'}</th>            
            <th></th>            
        </tr>
        {#each tiles as t, i}
        <tr class:selected="{i === selected2}" on:click="{ () => select22(i)}" >
            <td class="tile" style="overflow: hidden; text-overflow: ellipsis;">
                {t.tileName}
            </td>
            <td>
                <i class="icon info-circle"></i>
                <i class="icon setting-image" on:click="{() => select2(i)}"></i>
                <i class="icon square"></i>
            </td> 
        </tr>
        {/each}
    </table>
    <table style="table-layout: fixed ; width:80% " class="content" class:hidden="{!expanded}" cellpadding="0" cellspacing="0">
        <tr>
            <th>{'Обработанные продукты'}</th>            
            <th></th>            
        </tr>
        {#each geoTiffs as t, i}
        <tr class:selected="{i === selected3}" on:click="{() => select3(i)}" >
            <td  style="overflow: hidden; text-overflow: ellipsis;" >
                <i class="icon delete-image"></i>
                {t.tiffName}
            </td>
            <td >
                <i class="icon info-circle"></i>
                <i class="icon"></i>
                <i class="icon square"></i>
            </td> 
        </tr>
        {/each}
    </table>
</div>

<style>
.delete-image {
    background-image: url('img/delete-active.png');

    display: inline-block;
}

.setting-image {
    background-image: url('img/setting.png');

    display: inline-block;
}

</style>